// extracted by mini-css-extract-plugin
module.exports = {"statsTotals":"Monitoring_statsTotals__aKrQ5","title":"Monitoring_title__3my9i","label":"Monitoring_label__2VjXG","value":"Monitoring_value__3zYuh"};